// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2nsO7","log":"ModalInventoryLogs_log__3Lw2i","date":"ModalInventoryLogs_date__14oxT","userName":"ModalInventoryLogs_userName__2gQPX"};